import React from "react";
import LiveChat from "react-livechat";

const LiveChatFeat = () => typeof window !== `undefined` && <LiveChat license={11783997} />;

export default LiveChatFeat;
